import * as AUTH_ACTION_TYPES from './auth.constants';
import * as Redux from 'redux';
import { AuthActionTypes, AuthResponse } from './auth.types';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const login: Redux.ActionCreator<
  ReduxPromiseAction<
    AuthActionTypes, SimpleResponse<Promise<AuthResponse>>
  >
> = (email: string, password: string, fromEmailVerification: boolean): ReduxPromiseAction<
  AuthActionTypes, SimpleResponse<Promise<AuthResponse>>
> => ({
  type: AUTH_ACTION_TYPES.LOGIN,
  payload: callApi(
    process.env.REACT_APP_API + '/log/in',
    false,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password, fromEmailVerification })
    },
    true // Special flag to indicate this is a login api call
  ),
  meta: {email: email}
});

export const signout: Redux.ActionCreator<
  ReduxPromiseAction<
    AuthActionTypes, SimpleResponse<Promise<AuthResponse>>
  >
> = (): ReduxPromiseAction<AuthActionTypes, SimpleResponse<Promise<AuthResponse>>> => ({
  type: AUTH_ACTION_TYPES.SIGNOUT,
  payload: callApi(
    process.env.REACT_APP_API + '/log/out',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const forgotPassword: Redux.ActionCreator<
  ReduxPromiseAction<
    AuthActionTypes, SimpleResponse<Promise<AuthResponse>>
  >
> = (email: string): ReduxPromiseAction<AuthActionTypes, SimpleResponse<Promise<AuthResponse>>> => ({
  type: AUTH_ACTION_TYPES.FORGOT_PASSWORD,
  payload: callApi(
    process.env.REACT_APP_API + '/account/forgotpassword',
    false,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    }
  )
});



// WEBPACK FOOTER //
// ./src/auth/auth.actions.tsx